import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { paymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetWithholdDetailsQuery = ({
	paidMonth,
	paidYear,
}: {
	paidMonth: string;
	paidYear: string;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ withholdId }: { withholdId: string }) => {
			dispatch(uiActions.showSpinnerOverlay());
			return paymentsService.getWithholdDetails({
				paidYear,
				withholdId,
				paidMonth,
			});
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useGetWithholdDetailsQuery;
